import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import {
  ChartItemLabel,
  ChartTooltip,
  getChartValueShare,
} from '../../../Chart'
import { ProgressBar } from '../../../ProgressBar'
import Text from '../../../Text'
import { formatBirdviewKpiValue } from '../../DashboardBirdview.utils.charts'

import {
  checkHasBirdviewBarsChartRowOverdue,
  getBirdviewBarsChartRowTooltipRows,
  getBirdviewBarsChartSegmentStyle,
} from './BirdviewBarsChartRow.utils'

import * as styles from './BirdviewBarsChartRow.module.css'

function BirdviewBarsChartRow({
  isActive,
  isStacked,
  isTooltipBelow,
  item,
  maxValue,
  total,
  valueUnit,
  withShare,
  onEnter,
}) {
  const { t } = useTranslation()

  function handleMouseEnter() {
    onEnter(item.id)
  }

  return (
    <li className={styles.row} onMouseEnter={handleMouseEnter}>
      {isActive ? (
        <ChartTooltip
          className={classNames(styles.tooltip, {
            [styles.below]: isTooltipBelow,
          })}
          rows={getBirdviewBarsChartRowTooltipRows({
            isStacked,
            item,
            t,
            total,
            valueUnit,
            withShare,
          })}
          title={item.label}
        />
      ) : null}
      <ChartItemLabel className={styles.label} text={item.label} />
      <span className={styles.track}>
        {isStacked ? (
          <>
            <span
              className={styles.open}
              style={getBirdviewBarsChartSegmentStyle(item.open, maxValue)}
            />
            {checkHasBirdviewBarsChartRowOverdue(item) ? (
              <span
                className={styles.overdue}
                style={getBirdviewBarsChartSegmentStyle(item.overdue, maxValue)}
              />
            ) : null}
          </>
        ) : (
          <ProgressBar
            className={styles.bar}
            progress={getChartValueShare(item.value, maxValue)}
          />
        )}
      </span>
      <Text className={styles.value}>
        {formatBirdviewKpiValue({ t, unit: valueUnit, value: item.value })}
      </Text>
    </li>
  )
}

export default BirdviewBarsChartRow
